import React, { useContext, useEffect, useState } from "react";
// import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import Nav from "./nav";
import { Context } from "../redux/store";
import imgBrandLogo from "../images/brand-logo.png";
import imgbrandLogoWhite from "../images/brand-logo-white.png";
import imgbrandLogoSticky from "../images/bioline-sticky-logo.png";

function Header(props) {
  const { state, dispatch } = useContext(Context);

  const handleClick = () => {
    dispatch({ type: "SET_HAMBURGER_MENU", payload: !state.hamburgerMenu });
  };
  const handleLogoClick = () => {
    dispatch({ type: "SET_HAMBURGER_MENU", payload: false });
  };

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  return (
    <header
      className={`site-header ${props.headerClass} ${
        state.hamburgerMenu ? "site-header__active" : ""
      } ${scroll ? (state.hamburgerMenu ? "" : "sticky") : ""}`}
    >
      <div className="centered-content centered-content-lg">
        <div className="site-header__content">
          <div className="brand-logo">
            <Link to="/" onClick={handleLogoClick}>
              <div className="logo-primary">
                <img
                  src={imgBrandLogo}
                  style={{ height: 57, width: 240 }}
                  alt="BioLineRx Logo"
                />
              </div>
              <div className="logo-white">
                <img
                  src={imgbrandLogoWhite}
                  style={{ height: 57, width: 240 }}
                  alt="BioLineRx Logo"
                />
              </div>
              <div className="logo-sticky">
                <img
                  src={imgbrandLogoSticky}
                  style={{ height: 57, width: 240 }}
                  alt="BioLineRx Logo"
                />
              </div>
            </Link>
          </div>
          <div className="menu-icon" onClick={handleClick}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div className="nav-wrapper">
          <Nav />
        </div>
      </div>
    </header>
  );
}

export default Header;
